import PropTypes from 'prop-types';
import React from 'react';

import * as Modules from './modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
*/

const ModuleDispatcher = (props) => {
    const Component = Modules[props.__typename];
    if (Component) {
        return (
            <Component {...props} />
        );
    } else {
        return null;
    }
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    __typename: PropTypes.string.isRequired,
    relativeUrl: PropTypes.string
};

ModuleDispatcher.propTypes = propTypes;

export default ModuleDispatcher;
